import { ScoreTheme } from '../../types';

export const SCORE_DEFAULT_THEME: ScoreTheme = {
    size: {
        xs: {
            width: '24px',
            height: '24px',
            padding: 0,
            radius: '20%',
            fontSize: '0.625rem',
        },
        s: {
            width: '32px',
            height: '32px',
            padding: 0,
            radius: '20%',
            fontSize: '0.75rem',
        },
        m: {
            width: '40px',
            height: '40px',
            padding: 0,
            radius: '20%',
            fontSize: '0.875rem',
        },
        l: {
            width: '48px',
            height: '48px',
            padding: 0,
            radius: '20%',
            fontSize: '1rem',
        },
    },
    typographyFamily: 'body',
    fontWeight: 'bold',
    colors: {
        primary: {
            background: 'primary.base',
            text: 'common.white',
        },
        secondary: {
            background: 'secondary.base',
            text: 'common.white',
        },
        tertiary: {
            background: 'accent.base',
            text: 'common.white',
        },
    },
    fixedColors: {
        neutral: {
            background: 'neutral.lightest',
            text: 'common.black',
        },
        black: {
            background: 'common.black',
            text: 'common.white',
        },
        white: {
            background: 'common.white',
            text: 'common.black',
        },
    },
};
